import React from "react";
import CoursePestanasNav from "../components/CoursePestanasNav";
import "./Temario.css";

function TestExamen() {
  return (
    <div className="cds-campus-root">
      <CoursePestanasNav />
      <h2>Sección: Test de Examen</h2>
      <p>Simulaciones de examen completo.</p>
    </div>
  );
}

export default TestExamen;
